import {
  authUrlPre,
  urlPre,
  baseUrl,
  rtmUpmsPre,
  comPre,
} from 'comm/src/config'
import { createProgressBar, ParallelDownloader } from 'comm/src/utils/downloadFile'
import { reqService } from 'comm/src/plugins/request'
const passwordUrl = authUrlPre + '/user/resetPassword' // 修改密码
const logoutUrl = `${authUrlPre}/oauth/remove/token` // authUrlPre + '/jwt/signOut' 登出
const uploadFileUrl = urlPre + '/common/file/uploadFile' // 上传文件
const searchHistoryUrl = urlPre + '/currency/search/searchHistory' // 站点树搜索记录

//全局搜索（目前只有新余有该功能，但又放到了layout中处理）
export const pageGlobalUrl = rtmUpmsPre + '/remoteMeter/pageGlobal'

// 上传图片
export const uploadFile = async (data) => {
  const formData = new window.FormData()
  formData.append('type', 'aaa')
  formData.append('file', data, data.name || 'img' + new Date().getTime())
  const res = await reqService({
    method: 'POST',
    url: uploadFileUrl,
    data: formData,
  })
  return res
}
// 修改密码
export const updatePassword = async (data) => {
  const res = await reqService({
    method: 'POST',
    url: passwordUrl,
    params: data,
  })
  return res
}

// 登出
export const logout = async () => {
  const res = await reqService({
    method: 'get',
    url: logoutUrl,
  })
  return res
}

// 查询搜索记录
export const getSearchHistory = async (params) => {
  const res = await reqService({
    method: 'GET',
    url: searchHistoryUrl,
    params,
  })
  return res
}

// 保存搜索记录
export const postSearchHistory = async (data) => {
  const res = await reqService({
    method: 'POST',
    url: searchHistoryUrl,
    data,
  })
  return res
}
// 全局公共导出记录
export const exportRecord = async (data) => {
  const res = await reqService({
    method: 'POST',
    url: '/api/export/fileImportExport/getAllPage',
    data,
  })
  return res
}


// 根据文件id下载文件
export const downloadFileById = async (data) => {
  // const downloader = new ParallelDownloader(`${comPre}/downloadFile?fileId=${data.fileId}`, {
  //   chunkSize: 1024 * 1024 * 3, // 5MB
  //   maxConcurrent: 5
  // })
  // downloader.onProgress((progress) => {
  //   console.log(`进度: ${progress.percentage.toFixed(2)}%`);
  // });
  // downloader.startDownload().then(() => {
  //   console.log('下载完成');
  // }).catch(error => {
  //   console.error('下载失败:', error);
  // });
  const progressStr = createProgressBar({
    title: '文件下载中...',
    total: 100,
    current: 0,
    autoRemove: true
  });
  const res = await reqService({
    method: 'GET',
    url: `${comPre}/downloadFile`,
    params: data,
    responseType: 'blob',
    timeout: 60 * 60 * 60 * 1000,
    onDownloadProgress: (progressEvent) => {
      if (progressEvent.lengthComputable) {
        const loaded = progressEvent.loaded;
        const total = progressEvent.total;
        const progress = Math.round((loaded / total) * 100);
        progressStr.update(progress);
        if (progress >= 100) {
          progressStr.setTitle('下载完成！');
        }
      }
    }
  })
  return res


}

